export default __webpack_public_path__ + "static/media/settings.6fe7885b.svg";